"use client"

import { useSession } from "next-auth/react"
import OptimizedImage from "../ui/Image/OptimizedImage"
import Link from "next/link"
import { Routes } from "@/lib/routes"

interface H1CTAProps {
   showDescription?: boolean
   layout?: "stacked" | "inline"
}

export function H1CTA({ showDescription = false, layout = "inline" }: H1CTAProps) {
   const { data: session, status } = useSession()
   const isLoggedIn = status === "loading" || !!session?.user
   if (status === "loading" || session?.user) {
      return null
   }
   const containerClasses =
      layout === "stacked" ? "flex-col text-start" : "flex-col text-center md:flex-row md:text-left"

   return (
      <section className={`relative max-w-regular place-items-center font-satoshi ${layout === "stacked" && "px-0"}`}>
         <div
            className={`
      relative col-span-full flex w-full flex-col items-start justify-between gap-8 overflow-hidden rounded-2xl border p-8
      ${containerClasses}
      bg-[image:var(--cta-gradient)]
   `}
         >
            <div
               className={`
      relative z-10 flex items-start gap-4
      ${layout === "stacked" ? "flex-col" : "flex-col md:flex-row"}
   `}
            >
               <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-xl bg-white text-primary shadow-md dark:bg-gray-800">
                  <OptimizedImage
                     src={"/_logos/logo-restaurant-association-icon-only-color.webp"}
                     sizes="6vw"
                     quality={100}
                     alt="Restaurant Association Logo"
                     width={64}
                     height={64}
                     className="p-2"
                  />
               </div>
               <div>
                  <h1
                     className={`${showDescription ? "text-custom-3xl-bold leading-6" : "text-custom-3xl-semibold leading-6"} text-start font-lora font-bold text-gray-900 dark:text-white`}
                  >
                     Become A Member Of The American Restaurant Association!
                  </h1>
                  {showDescription && (
                     <p className="text-custom-2xl- mt-2 text-start text-black">
                        Unlock Exclusive Access To Webinars, Events, And The Latest News For Free!
                     </p>
                  )}
               </div>
            </div>
            {!isLoggedIn && (
               <div className="relative z-10 flex-shrink-0">
                  <Link
                     href={Routes.client.unifiedSignup.getPath()}
                     className="inline-block transform rounded-lg bg-custom-primary px-8 py-3 font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-orange-600 active:scale-95"
                  >
                     Sign Up
                  </Link>
               </div>
            )}
         </div>
      </section>
   )
}
